import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@environments/environment';

import { TranslateService } from '@ngx-translate/core';
import { TextTranslateService } from '@shared/services/text-translate/text-translate.service';

// Config
import { Config } from '@core/config/config';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public isLoadingApp = true;
  public isProduction = environment.production;
  private destroy$ = new Subject<boolean>();

  public version = environment.version;

  constructor(
    private translate_service: TranslateService,
    private text_translate_service: TextTranslateService
  ) {}
  ngOnInit() {
    setTimeout(() => (this.isLoadingApp = false), Config.LOADING_APP_TIME);
    this.initTranslationSubscription();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private initTranslationSubscription() {
    this.translate_service.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.text_translate_service.initializeCommonText().then();
      });
  }
}
